<template>
  <div>
    <div>
      <div class="row align-items-center">
          <div class="col col-11">
            <div class="card-header border-0">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label page-title fw-bolder fs-3 mb-1"
                >Workers</span
                >
              </h3>
            </div>
          </div>
          <div class="col">
              <button
                  type="button"
                  @click="initalGetWorkers()"
              >
                  <i class="fas fa-redo fa-2x"></i>

              </button>
          </div>
      </div>

      <input
      type="text"
      class="form-control form-control-lg form-control-solid px-15"
      v-model="search"
      placeholder="Search by Worker Name, Email, Type, Status, Sign up"
      data-kt-search-element="input"
      />
      <!--end::Input-->
    </div>

    <div class="spacer-y-10"></div>

      <!--begin::Table container-->
    <v-data-table
      :headers="tableHeaders"
      :items="searchResults"
      item-key="pybNumber"
      class="elevation-1"
      :loading="loadingList"
      loading-text="Loading Workers..."
      :page.sync="currentPage"
      @page-count="pageCount = $event"
    >
      <template v-slot:[`item.workerName`]="{ item }">
          {{ workerName(item) }}
      </template>

      <template v-slot:[`item.email`]="{ item }">
        <a href="#adminComponent" @click="viewWorkerInfo(item)">{{ item.email }}</a>
      </template>

      <template v-slot:[`item.signUpDate`]="{ item }">
          {{ formatDate(item.signUpDate) }}
      </template>

    </v-data-table>
    <!--end::Table-->

    <Modal v-show="showWorkerModal" @close="closeWorkerInfo()">
      <template v-slot:body>
        <ConfirmationModal
          :isLoadingConfirmation="loadingConfirmation"
          :isShowDialog="isShowConfirmationModal"
          :btnConfig="buttonConfiguration"
          :inputInfo="confirmationModalInfo"
          :inputColor="confirmationModalInfoColor"
          @eConfirm="confirmActionDecider"
          @eCancel="defaultCancelOperation"
        />
        <SnackbarNotifier
          :isShow="isShowSnackBar"
          :message="responseMessage"
          :snackType="snackbarType"
          :colour="snackBarColour"
          @eReset="resetSnackBar"
        />
        <div>
          <v-row align="center">
            <h1 v-if="!editMode">{{workerName(selectedWorker)}}</h1>
            <v-col cols="6" v-if="editMode">
              <input type="text"
                v-model="firstName"
                :placeholder="updatedWorker.firstName"
                class="custom-select form-control form-control-lg form-control-solid"
                @input="updateFirstName()"
              />
            </v-col>
            <v-col cols="6" v-if="editMode">
              <input type="text"
                v-model="lastName"
                :placeholder="updatedWorker.lastName"
                class="custom-select form-control form-control-lg form-control-solid"
                @input="updateLastName()"
              />
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <div>
          <v-row v-for="(workerDetail, index) in workerDetails" :key="workerDetail.var">
            <v-col cols="2" align-self="center">
              <strong>{{workerDetail.title}}</strong>
            </v-col>
            <v-col cols="9" v-if="!editMode || editMode && !workerDetail.canEdit">
              <em>{{workerDetailValue(workerDetail.value)}}</em>
            </v-col>
            <v-col cols="9" v-if="editMode && workerDetail.canEdit">
              <input type="text"
                v-model="workerDetails[index].updatedValue"
                :placeholder="workerDetailValue(workerDetail.value)"
                class="custom-select form-control form-control-lg form-control-solid"
                @input="updateWorkerInfo(workerDetail)"
              />
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </div>
        <div>
          <v-row align="center" v-if="!editMode">
            <v-col cols="6"><v-btn color="hsl(0, 100%, 94%)" @click="deleteWorkerConfirmation()">Delete</v-btn></v-col>
            <v-col cols="6"><v-btn @click="editMode = true">Edit</v-btn></v-col>
          </v-row>
          <v-row align="center" v-if="editMode">
            <v-col cols="6"><v-btn @click="cancel()">Cancel Edit</v-btn></v-col>
            <v-col cols="6"><v-btn color="hsl(147, 100%, 69%)" :disabled="!canUpdate" @click="updateWorkerConfirmation()">Update</v-btn></v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:footer>
        <button class="btn btn-primary" @click="closeWorkerInfo()">Close</button>
      </template>
    </Modal>


  </div>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { ApiService } from '@/services/ApiService';
import { error } from '@/services/LoggerService';
import dayjs from "dayjs";
import mixins from "vue-typed-mixins";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";

export default mixins(ConfirmationModalMixin,SnackbarNotifierMixin).extend({
  name: 'ManageWorkers',
  components: { Modal, ConfirmationModal, SnackbarNotifier },
  data() {
    return {
      showWorkerModal: false,
      loadingList: false,
      search: "",
      limit: 1000,
      pullLimit: 1000,
      startKey: null,
      firstName: "",
      lastName: "",
      confirmAction: "",
      selectedWorker: {},
      updatedWorker: {},
      editMode: false,
      workerDetails: [],
      workers: [],
      pageCount: 0,
      currentPage: 1,
      tableHeaders: [
        { text: 'Name', value: 'workerName'},
        { text: "Email", value: "email"},
        { text: "Type", value: "type"},
        { text: "Company", value: "company"},
        { text: "Status", value: "status" },
        { text: "Sign Up", value: "signUpDate" }
      ],
    }
  },
  computed: {
    searchResults() {
      if(!this.search) return this.workers;

      return this.workers.filter((a) => {
        return (
            this.workerName(a).toLowerCase().includes(this.search.toLowerCase()) ||
            a.email.toLowerCase().includes(this.search.toLowerCase()) ||
            a.type.toLowerCase().includes(this.search.toLowerCase()) ||
            a.company?.toLowerCase().includes(this.search.toLowerCase()) ||
            a.status?.toLowerCase().includes(this.search.toLowerCase()) ||
            this.formatDate(a.signUpDate).toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
    isLastPage(){
      return (this.pageCount < 1)
        ? false
        : this.currentPage >= this.pageCount;
    },
    canUpdate(){
      let allowUpdate = false;

      this.workerDetails.forEach(detail => {
        if(detail.canEdit){
          if(this.selectedWorker[detail.var] != this.updatedWorker[detail.var]){
            allowUpdate = true;
          }
        }
      })

      return this.selectedWorker.firstName != this.updatedWorker.firstName ||
      this.selectedWorker.lastName != this.updatedWorker.lastName || allowUpdate;
    }
  },
  watch: {
    isLastPage(newValue) {
      if(!newValue){
        return;
      }
      this.loadMoreData();
    }
  },
  methods: {
    viewWorkerInfo(item){
      this.selectedWorker = {...item};
      this.updatedWorker = {...item};
      //1. var should match the value from tableHeaders
      //2. attribute should match the attribute that is in the database (case sensitive)
      //NOTE: if worker detail has the canEdit set to true it must have an attribute value and adhere to point #2
      this.workerDetails = [
        { title: 'Type', var: 'type', value: item.type },
        { title: 'Email', var: 'email', value: item.email },
        { title: 'Company', var: 'company', value: item.company, canEdit: true, attribute: 'Company' },
        { title: 'Status', var: 'status', value: item.status },
        { title: 'Sign up', var: 'signUpDate', value: this.detailedDate(item.signUpDate) },
      ]

      this.showWorkerModal = true;
    },
    workerDetailValue(value){
      return (!value) ? "N/A" : value;
    },
    updateFirstName(){
      this.updatedWorker.firstName = (!this.firstName)
        ? this.selectedWorker.firstName : this.firstName;
    },
    updateLastName(){
      this.updatedWorker.lastName = (!this.lastName)
        ? this.selectedWorker.lastName : this.lastName;
    },
    updateWorkerInfo(workerDetail){
      this.updatedWorker[workerDetail.var] = (!workerDetail.updatedValue)
        ? this.selectedWorker[workerDetail.var] : workerDetail.updatedValue;
    },
    cancel(){
      this.updatedWorker = {...this.selectedWorker};
      this.editMode = false;
      this.inputValue = "";
      this.firstName = "";
      this.lastName = "";
    },
    closeWorkerInfo(){
      this.selectedWorker = {};
      this.updatedWorker = {};
      this.cancel();
      this.showWorkerModal = false;
    },
    workerName(input){
      return `${input.firstName} ${input.lastName}`;
    },
    formatDate(date){
      if(!date) return "";

      try{
        return dayjs(date).format("DD-MMM-YY");
      }catch{
        return ""
      }
    },
    detailedDate(date){
      if(!date) return "";

      try{
        return dayjs(date).format("MMMM DD, YYYY [at] hh:mma");
      }catch{
        return ""
      }
    },
    async loadMoreData(){
      if(!this.startKey) return;
      await this.getWorkers(this.startKey);
    },
    async initalGetWorkers(){
      this.workers = [];
      this.startKey = null;
      await this.getWorkers();
    },
    async getWorkers(startKey) {
      try{
        do{
          this.loadingList = true;
          const result = await ApiService.Instance.getAllWorkers({
              headers: {
                  startKey,
                  limit: this.limit
              }
          });

          if(!!result.data){
              this.workers.push(...result.data);
          }

          startKey = result.lastEvaluatedKey;
          this.startKey = result.lastEvaluatedKey;
        }while(this.workers < this.pullLimit && !!this.startKey);
      }catch(e){
          this.showNotifier({
            message: "Failed To Load Workers",
            snackbarType: "error",
          });
          error(e);
      }
      this.loadingList = false;
    },
    async updateWorker(){
      this.startConfirmationLoading();

      let input = {
        id: this.selectedWorker.id,
        type: this.selectedWorker.type,
        updates: this.prepUpdates()
      }

      if(!input.updates.length) return;

      try{
        await ApiService.Instance.updateWorker(input);
        this.stopConfirmationLoading();
        this.closeWorkerInfo();
        this.initalGetWorkers();
      }catch(e){
        this.showNotifier({
          message: "Failed To Update Worker",
          snackbarType: "error",
        });
        this.stopConfirmationLoading();
        error(e);
      }
    },
    updateWorkerConfirmation(){
      this.confirmAction = 'update';
      this.showConfirmationModal({
        title: "Update Worker",
        message: "Are you sure you want to update this worker?",
      });
    },
    async deleteWorker(){
      this.startConfirmationLoading();

      try{
        await ApiService.Instance.deleteWorker({id: this.selectedWorker.id});
        this.stopConfirmationLoading();
        this.closeWorkerInfo();
        this.initalGetWorkers();
      }
      catch(e){
        this.showNotifier({
          message: "Failed To Update Worker",
          snackbarType: "error",
        });
        this.stopConfirmationLoading();
        error(e);
      }
    },
    deleteWorkerConfirmation(){
      this.confirmAction = 'delete';
      this.showConfirmationModal({
        title: "Delete Worker",
        message: "Are you sure you want to delete this worker?",
      });
    },
    async confirmActionDecider(){
      if(this.confirmAction === 'update') await this.updateWorker();

      if(this.confirmAction === 'delete') await this.deleteWorker();
    },
    prepUpdates(){
      let updates = [];

      if(this.selectedWorker.firstName != this.updatedWorker.firstName) updates.push({
        attribute: 'FirstName',
        value: this.updatedWorker.firstName
      })

      if(this.selectedWorker.lastName != this.updatedWorker.lastName) updates.push({
        attribute: 'LastName',
        value: this.updatedWorker.lastName
      })

      this.workerDetails.forEach(detail => {
        if(detail.canEdit){
          if(this.selectedWorker[detail.var] != this.updatedWorker[detail.var]) updates.push({
            attribute: detail.attribute,
            value: this.updatedWorker[detail.var]
          })
        }
      })

      return updates;
    }
  },
  async beforeMount () {
    await this.initalGetWorkers();
  },
})
</script>